import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Check if user has already purchased a specific test series
 * @param {string} userId - User's UID
 * @param {string} seriesId - Series/Course ID
 * @returns {Promise<boolean>} - True if purchased
 */
export const checkIfPurchased = async (userId, seriesId) => {
  try {
    const q = query(
      collection(db, "transactions"),
      where("userId", "==", userId),
      where("courseId", "==", seriesId),
      where("status", "==", "success")
    );
    
    const querySnapshot = await getDocs(q);
    return !querySnapshot.empty; // Returns true if any purchase found
  } catch (error) {
    console.error("Error checking purchase status:", error);
    return false;
  }
};

/**
 * Get all purchased courses for a user
 * @param {string} userId - User's UID
 * @returns {Promise<Array>} - Array of purchased courses
 */
export const getUserPurchases = async (userId) => {
  try {
    const q = query(
      collection(db, "transactions"),
      where("userId", "==", userId),
      where("status", "==", "success")
    );
    
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error("Error fetching purchases:", error);
    return [];
  }
};
